// Remove our preload class from the body, preventing early CSS transitions
//
// Use `readystatechange` to have this triggered after `defer` and `module` scripts
// otherwise we get a nasty flash during dev.
document.addEventListener('DOMContentLoaded', () => {
    document.body.classList.remove('preload');
});
